(function () {
  /* ---- Hauteur reelle de l'ecran + "rafraichissement" force de l'affichage (bug Safari iPhone) ---- */
  if (!window.__mpnVh) {
    window.__mpnVh = true;
    var setVh = function () {
      var h = (window.visualViewport && window.visualViewport.height) || window.innerHeight;
      var ih = window.innerHeight || h;
      document.documentElement.style.setProperty('--mpn-vh', Math.max(h, ih) + 'px');
    };
    /* Safari ne peint parfois que la partie visible d'une zone qui defile dans une fenetre fixe :
       on la fait "bouger" d'un pixel et on force un nouveau calcul, ce qui l'oblige a tout redessiner */
    var repaint = function (el) {
      if (!el) return;
      var run = function () {
        el.style.transform = 'translateZ(0)';
        void el.offsetHeight;
        var t = el.scrollTop;
        el.scrollTop = t + 1;
        requestAnimationFrame(function () {
          el.scrollTop = t;
          el.style.transform = '';
        });
      };
      requestAnimationFrame(run);
      setTimeout(run, 120);
      setTimeout(run, 420);
    };
    window.mpnSetVh = setVh;
    window.mpnRepaint = repaint;
    setVh();
    window.addEventListener('resize', setVh);
    window.addEventListener('orientationchange', function () { setTimeout(setVh, 300); });
    if (window.visualViewport) window.visualViewport.addEventListener('resize', setVh);
    var watchDrawer = function () {
      var d = document.querySelector('cart-drawer');
      if (!d || d.__mpnVhWatch) return;
      d.__mpnVhWatch = true;
      new MutationObserver(function () {
        if (d.classList.contains('active')) {
          setVh();
          repaint(d.querySelector('cart-drawer-items'));
          repaint(d.querySelector('.drawer__inner'));
        }
      }).observe(d, { attributes: true, attributeFilter: ['class'] });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchDrawer); else watchDrawer();
  }

  /* ---- "Vouliez-vous dire ... ?" : correction des fautes a partir du vocabulaire du site ---- */
  if (!window.mpnDidYouMean) {
    var vocab = null;
    var norm = function (s) {
      s = String(s || '').toLowerCase();
      if (s.normalize) s = s.normalize('NFD').replace(/[̀-ͯ]/g, '');
      return s.replace(/ß/g, 'ss').replace(/[^a-z0-9]+/g, ' ').trim();
    };
    var buildVocab = function () {
      vocab = {};
      var raw = '';
      try { raw = JSON.parse(document.getElementById('MpnSearchDict').textContent) || ''; } catch (e) {}
      String(raw).split('|').forEach(function (phrase) {
        String(phrase).split(/[\s,\/\-–&()]+/).forEach(function (w) {
          w = w.trim();
          var n = norm(w);
          if (n.length < 3 || /^\d+$/.test(n) || n.indexOf(' ') > -1) return;
          if (!vocab[n]) vocab[n] = w.toLowerCase();
        });
      });
    };
    var lev = function (a, b, max) {
      if (Math.abs(a.length - b.length) > max) return max + 1;
      var prev = [], i, j;
      for (j = 0; j <= b.length; j++) prev[j] = j;
      for (i = 1; i <= a.length; i++) {
        var cur = [i], rowMin = i;
        for (j = 1; j <= b.length; j++) {
          var c = a[i - 1] === b[j - 1] ? 0 : 1;
          cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + c);
          if (cur[j] < rowMin) rowMin = cur[j];
        }
        if (rowMin > max) return max + 1;
        prev = cur;
      }
      return prev[b.length];
    };
    window.mpnDidYouMean = function (q) {
      if (!vocab) buildVocab();
      var words = String(q || '').trim().split(/\s+/).filter(Boolean);
      if (!words.length) return null;
      var changed = false;
      var out = words.map(function (w) {
        var n = norm(w);
        if (n.length < 4 || /\d/.test(n) || vocab[n]) return w;
        var max = n.length <= 5 ? 1 : (n.length <= 8 ? 2 : 3);
        var best = null, bestD = max + 1;
        for (var k in vocab) {
          var d = lev(n, k, max);
          if (d < bestD || (d === bestD && best && Math.abs(k.length - n.length) < Math.abs(best.length - n.length))) { bestD = d; best = k; }
        }
        if (best && bestD <= max) { changed = true; return vocab[best]; }
        return w;
      });
      if (!changed) return null;
      var res = out.join(' ');
      return norm(res) === norm(q) ? null : res;
    };
  }

  if (window.__mpnSearch) return; window.__mpnSearch = true;

  var RECENT_KEY = 'mpnRecentSearches', RECENT_MAX = 6;
  /* « Vus récemment » mémorisé par langue (titres, prix et liens dans la langue de la boutique) ; FR garde la clé d'origine */
  var mpnLang = (document.documentElement.lang || 'fr').slice(0, 2).toLowerCase();
  var VIEWED_KEY = 'mpnRecentlyViewed' + (mpnLang === 'fr' ? '' : '_' + mpnLang), VIEWED_MAX = 8;
  var CLOCK = '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="8.5"/><path d="M12 7.5V12l3 2"/></svg>';

  function readList(key) {
    try { var a = JSON.parse(localStorage.getItem(key) || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; }
  }
  function writeList(key, a) { try { localStorage.setItem(key, JSON.stringify(a)); } catch (e) {} }

  function rememberViewed() {
    var el = document.getElementById('MpnViewedCurrent');
    if (!el) return null;
    var p; try { p = JSON.parse(el.textContent); } catch (e) { return null; }
    if (!p || !p.h) return null;
    var a = readList(VIEWED_KEY).filter(function (x) { return x && x.h !== p.h; });
    a.unshift(p);
    writeList(VIEWED_KEY, a.slice(0, VIEWED_MAX));
    /* « Vus récemment » ramène au dernier FORMAT consulté (variante), pas seulement au produit (demande d'Ed) */
    var base = String(p.u || '').split('?')[0], lastV = '';
    function curV() {
      var f = document.querySelector('.product__info-container form[id^="product-form-"]:not([id*="installment"]) [name="id"]') || document.querySelector('form[action*="/cart/add"] [name="id"]');
      var v = f && f.value;
      if (!v) { var m = location.search.match(/[?&]variant=(\d+)/); v = m && m[1]; }
      return v ? String(v) : '';
    }
    function keepV() {
      var v = curV(); if (!v || v === lastV) return; lastV = v;
      var list = readList(VIEWED_KEY), hit = false;
      list.forEach(function (x) { if (x && x.h === p.h) { x.u = base + '?variant=' + v; hit = true; } });
      if (hit) writeList(VIEWED_KEY, list);
    }
    keepV(); setInterval(keepV, 1200);
    return p.h;
  }

  function init() {
    var currentHandle = rememberViewed();
    var so = document.getElementById('MpnSearchOverlay');
    if (!so) return;
    if (so.parentNode !== document.body) document.body.appendChild(so);

    var input = so.querySelector('.mpn-so__input');
    var form = so.querySelector('.mpn-so__form');
    var clearBtn = so.querySelector('[data-mpn-so-clear]');
    var home = so.querySelector('[data-mpn-so-home]');
    var results = so.querySelector('[data-mpn-so-results]');
    var body = so.querySelector('.mpn-so__body');
    var recentSec = so.querySelector('[data-mpn-so-recent]');
    var recentList = so.querySelector('[data-mpn-so-recent-list]');
    var viewedSec = so.querySelector('[data-mpn-so-viewed]');
    var viewedList = so.querySelector('[data-mpn-so-viewed-list]');
    var root = so.dataset.root || '/';
    if (root.slice(-1) !== '/') root += '/';
    var searchUrl = so.dataset.search || '/search';
    var isOpen = false, pushed = false, timer = 0, ctrl = null, lastQ = '';
    var desktop = window.matchMedia('(hover: hover) and (pointer: fine)');

    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
    function allUrl(q) { return searchUrl + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last'; }

    function saveRecent(q) {
      q = String(q || '').trim();
      if (q.length < 2) return;
      var a = readList(RECENT_KEY).filter(function (x) { return String(x).toLowerCase() !== q.toLowerCase(); });
      a.unshift(q);
      writeList(RECENT_KEY, a.slice(0, RECENT_MAX));
    }
    function renderRecent() {
      var a = readList(RECENT_KEY);
      if (!a.length) { recentSec.hidden = true; recentList.innerHTML = ''; return; }
      recentList.innerHTML = a.map(function (q) {
        return '<li><a class="mpn-so__chip" data-mpn-q="' + esc(q) + '" href="' + esc(allUrl(q)) + '">' + CLOCK + esc(q) + '</a></li>';
      }).join('');
      recentSec.hidden = false;
    }
    function renderViewed() {
      var a = readList(VIEWED_KEY).filter(function (x) { return x && x.u && x.h !== currentHandle; });
      if (!a.length) { viewedSec.hidden = true; viewedList.innerHTML = ''; return; }
      viewedList.innerHTML = a.map(function (p) {
        return '<li class="mpn-so__vcard"><a href="' + esc(p.u) + '">' +
          '<span class="mpn-so__vcard-img">' + (p.i ? '<img src="' + esc(p.i) + '" alt="">' : '') + '</span>' +
          '<span class="mpn-so__vcard-t">' + esc(p.t) + '</span>' +
          (p.p ? '<span class="mpn-so__vcard-p">' + esc(p.p) + '</span>' : '') +
          '</a></li>';
      }).join('');
      viewedSec.hidden = false;
    }

    var phBase = so.dataset.ph || input.placeholder;
    var phAnim = so.dataset.phAnim || '{t}';
    var terms = (so.dataset.terms || '').split('|').filter(function (t) { return t.trim(); });
    var phTimer = 0, phIdx = 0;
    function phStop() { clearTimeout(phTimer); phTimer = 0; input.placeholder = phBase; }
    function phRun() {
      phStop();
      if (!terms.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var parts = phAnim.split('{t}');
      var term = terms[phIdx % terms.length]; phIdx++;
      var i = 0;
      (function type() {
        if (!isOpen || input.value || document.activeElement === input) { phStop(); return; }
        input.placeholder = parts[0] + term.slice(0, i) + (i >= term.length ? (parts[1] || '') : '');
        if (i < term.length) { i++; phTimer = setTimeout(type, 70); }
        else { phTimer = setTimeout(function () { if (isOpen && !input.value && document.activeElement !== input) phRun(); }, 1600); }
      })();
    }

    function open(prefill) {
      if (isOpen) return;
      isOpen = true;
      if (window.mpnSetVh) window.mpnSetVh();
      renderRecent();
      renderViewed();
      so.classList.add('is-open');
      so.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('mpn-so-open');
      if (body) body.scrollTop = 0;
      if (typeof prefill === 'string' && prefill) { input.value = prefill; }
      if (desktop.matches) {
        try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); }
      } else {
        if (document.activeElement && document.activeElement.blur) document.activeElement.blur();
        setTimeout(phRun, 350);
      }
      update();
      try { history.pushState({ mpnSo: 1 }, ''); pushed = true; } catch (e) { pushed = false; }
      if (window.mpnRepaint) window.mpnRepaint(body);
      setTimeout(function () { if (window.mpnSetVh) window.mpnSetVh(); }, 260);
    }
    function close(fromPop) {
      if (!isOpen) return;
      isOpen = false;
      phStop();
      so.classList.remove('is-open');
      so.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('mpn-so-open');
      input.blur();
      if (!fromPop && pushed && history.state && history.state.mpnSo) { pushed = false; history.back(); }
      pushed = false;
    }
    window.mpnOpenSearch = open;

    function addDidYouMean(q) {
      var res = results.querySelector('.mpn-so-res');
      if (!res || res.getAttribute('data-total') !== '0' || !window.mpnDidYouMean) return;
      var s = window.mpnDidYouMean(q);
      if (!s) return;
      var box = document.createElement('p');
      box.className = 'mpn-so__dym';
      var dq = (so.dataset.dymQ || '« | »| ?').split('|');
      box.innerHTML = esc(so.dataset.dym || 'Vouliez-vous dire') + ' <button type="button" data-mpn-dym="' + esc(s) + '">' + esc(dq[0] || '') + esc(s) + esc(dq[1] || '') + '</button>' + esc(dq[2] || '');
      res.insertBefore(box, res.firstChild);
    }

    function fetchResults(q) {
      if (ctrl && ctrl.abort) ctrl.abort();
      ctrl = ('AbortController' in window) ? new AbortController() : null;
      results.classList.add('is-loading');
      /* 10 résultats (maximum de l'API) et produits épuisés gardés à leur rang de pertinence (show plutôt que « last ») : un produit épuisé
         dont le titre correspond à la recherche est ensuite remonté par sections/mpn-predictive.liquid (demande d'Ed, oct. 2026) */
      var url = root + 'search/suggest?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,query,article&resources[limit]=10&resources[limit_scope]=each' +
        '&resources[options][unavailable_products]=show&resources[options][fields]=title,product_type,variants.title,vendor,tag' +
        '&section_id=mpn-predictive';
      fetch(url, ctrl ? { signal: ctrl.signal } : {})
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          if (input.value.trim() !== q) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var res = doc.querySelector('.mpn-so-res');
          results.innerHTML = res ? res.outerHTML : '';
          results.classList.remove('is-loading');
          addDidYouMean(q);
          if (window.mpnRepaint) window.mpnRepaint(body);
        })
        .catch(function (e) { if (!e || e.name !== 'AbortError') results.classList.remove('is-loading'); });
    }
    function update() {
      var q = input.value.trim();
      clearBtn.hidden = !input.value;
      if (q.length < 2) {
        lastQ = '';
        if (ctrl && ctrl.abort) ctrl.abort();
        results.hidden = true; results.innerHTML = ''; results.classList.remove('is-loading');
        home.hidden = false;
        return;
      }
      home.hidden = true;
      results.hidden = false;
      if (q === lastQ) return;
      lastQ = q;
      clearTimeout(timer);
      timer = setTimeout(function () { fetchResults(q); }, 200);
    }

    input.addEventListener('input', function () { phStop(); update(); });
    input.addEventListener('focus', phStop);
    input.addEventListener('blur', function () { if (isOpen && !input.value && !desktop.matches) setTimeout(phRun, 600); });
    clearBtn.addEventListener('click', function () { input.value = ''; update(); input.focus(); if (window.mpnRepaint) window.mpnRepaint(body); });
    form.addEventListener('submit', function (e) {
      var q = input.value.trim();
      if (!q) { e.preventDefault(); input.focus(); return; }
      saveRecent(q);
    });
    so.addEventListener('click', function (e) {
      if (e.target.closest('[data-mpn-so-close]')) { close(false); return; }
      var dym = e.target.closest('[data-mpn-dym]');
      if (dym) { input.value = dym.getAttribute('data-mpn-dym'); update(); return; }
      if (e.target.closest('[data-mpn-so-recent-clear]')) {
        try { localStorage.removeItem(RECENT_KEY); } catch (err) {}
        renderRecent();
        return;
      }
      var a = e.target.closest('a');
      if (!a) return;
      if (a.hasAttribute('data-mpn-q')) saveRecent(a.getAttribute('data-mpn-q'));
      else if (input.value.trim().length >= 2) saveRecent(input.value.trim());
    });
    if (body) body.addEventListener('touchstart', function () { if (document.activeElement === input) input.blur(); }, { passive: true });
    document.addEventListener('keydown', function (e) { if (isOpen && e.key === 'Escape') close(false); });
    window.addEventListener('popstate', function () { if (isOpen) close(true); });
    window.addEventListener('pageshow', function (e) { if (e.persisted && isOpen) close(true); });

    var TRIGGER = 'details-modal.header__search summary, .header__search summary, .header__icon--search, [data-mpn-search-open]';
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest(TRIGGER);
      if (!t || so.contains(t)) return;
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      var d = t.closest('details');
      if (d && d.hasAttribute('open')) d.removeAttribute('open');
      open();
    }, true);
    document.addEventListener('focusin', function (e) {
      var f = e.target;
      if (!f || !f.matches || !f.matches('input[type="search"], input[name="q"]')) return;
      if (so.contains(f)) return;
      if (!f.closest('.menu-drawer, #menu-drawer, header-drawer, .header__search, details-modal')) return;
      var v = f.value;
      f.blur();
      open(v);
    }, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
